import { iconSize } from '@guardian/src-foundations/size';
import type { IconProps } from './types';

export const SvgExternal = ({ size }: IconProps) => {
	return (
		<svg
			viewBox="0 0 30 30"
			xmlns="http://www.w3.org/2000/svg"
			width={size ? iconSize[size] : undefined}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M25.9999 13.75H24.7499L24.1499 9.22499L18.4 15L17 13.575L22.7249 7.82499L18.25 7.25V6H25.5249L25.9999 6.475V13.75ZM14 11L12.975 12H5.99999V21.9999H21.9999V17L22.9749 16H23.9999V22.9749L22.9749 23.9999H4.975L4 22.9749V11L4.975 9.99999H14V11Z"
			/>
		</svg>
	);
};
